// App-level constants.

// The founder's uid: used as a filled-out profile example for onboarding,
// and every new signup auto-follows this account (see AuthContext) so the
// Following/Featured features have something to show on day one.
export const FOUNDER_UID = 'dag0HRLPYyPtV4pgKe7T7WkQrzB3';

// Brand-new users are sent here right after their first sign-in: the
// founder's public profile. See AuthPage.
export const ONBOARDING_PROFILE_PATH = `/user/${FOUNDER_UID}`;
